import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/overview';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Pull the purpose-built /signal/overview payload for the workspace overview
// chart. The BE resolves a hierarchical view (per-signal series for small
// workspaces, namespace group envelopes for large ones, drill-down via
// ``group``, explicit overlays via ``pins``) so the chart stays readable and
// the payload stays bounded no matter how many thousands of signals exist.
// It mirrors the grid's active filters (date window) via ``payload.query``.
function* operation(action) {
  try {
    const q = action?.payload?.query ? `&${action.payload.query}` : '';
    const group = action?.payload?.group
      ? `&group=${encodeURIComponent(action.payload.group)}` : '';
    const pins = (action?.payload?.pins || []).length
      ? `&pins=${encodeURIComponent(action.payload.pins.join(','))}` : '';
    // Higher bin resolution so the interactive overview chart has real detail
    // to zoom into (stock-chart style), not just a coarse ~36-point line.
    const response = yield call(
      axios.get,
      `${config.API_URL}/signal/overview?number_of_bins=240${q}${group}${pins}`,
      { headers: getLocalUser() },
    );
    const body = response?.data?.data?.data ?? {};
    yield put(fetchSuccess(body));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
